import { MapPin } from 'lucide-react';
import './V2SceneFrame.css';

export function V2SceneFrame({ locationName = 'Special Stop', neighborhoodName = '', onExit, children }) {
  return <div className="v2-scene-frame">
    <header className="v2-scene-frame-bar">
      <div><span>UI v2 · SCENE</span><strong>{locationName}</strong>{neighborhoodName && <small><MapPin /> {neighborhoodName}</small>}</div>
      <em>SPECIAL LOCATION</em>
    </header>
    <div className="v2-scene-content">
      <div className="v2-scene-frame-fallback" role="status">
        <strong>{locationName}</strong>
        <p>This scene is no longer active.</p>
        {onExit && <button type="button" onClick={onExit}>Return to game</button>}
      </div>
      {children}
    </div>
  </div>;
}
